import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Box, useColorMode, Fab, HStack, Spinner, Heading } from "native-base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Components/PreLogin/Login";
import PageNotFound from "./Components/shared/PageNotFound";
import SignUp from "./Components/PreLogin/SignUp";
import Home from "./Components/AfterLogin/Home";
import Main from "./Components/AfterLogin/Main";

function App() {
  const { colorMode, toggleColorMode } = useColorMode();
  const [isLoading, setIsLoading] = useState(true);
  const [userId, setUserId] = useState(null);

  const fetchUsers = async () => {
    try {
      const userSession = Cookies.get("userSession");
      if (userSession !== undefined) {
        return userSession; // Return user ID if found
      } else return null; // Return null if user ID not found
    } catch (error) {
      console.error("Error fetching user data:", error);
      return null; // Return null in case of error
    }
  };

  const getLogInCheck = () => {
    fetchUsers().then((userId) => {
      setUserId(userId);
    });
  };

  const logOut = () => {
    Cookies.remove("userSession");
    setUserId(null);
  };

  useEffect(() => {
    fetchUsers().then(async (userId) => {
      setUserId(userId);
      await setIsLoading(false);
    });
  }, []);

  return (
    <>
      <ToggleDarkMode toggleColorMode={toggleColorMode} colorMode={colorMode} />
      <Box
        bg={colorMode === "light" ? "light.50" : "coolGray.900"}
        minHeight="100vh"
      >
        {isLoading ? (
          <HStack space={8} justifyContent="center" alignItems="center">
            <Spinner _dark={{ color: "white" }} size="lg" />
            <Heading
              _dark={{ color: "white" }}
              color="primary.500"
              fontSize="md"
            >
              Please Wait, We are Getting ready for you...
            </Heading>
          </HStack>
        ) : (
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <Home logOut={logOut} />
                }
              />
              <Route
                path="/SignIn"
                element={
                  <PreLoginPAth isLoggedIn={userId}>
                    <Login callAppFunction={getLogInCheck} />
                  </PreLoginPAth>
                }
              />
              <Route
                path="/SignUp"
                element={
                  <PreLoginPAth isLoggedIn={userId}>
                    <SignUp />
                  </PreLoginPAth>
                }
              />
              <Route
                path="/Home"
                element={
                  <PrivateRoute isLoggedIn={userId}>
                    <Home logOut={logOut} />
                  </PrivateRoute>
                }
              />
              <Route
                path="/CompleteProfile"
                element={
                  <PrivateRoute isLoggedIn={userId}>
                    <Main />
                  </PrivateRoute>
                }
              />
              <Route
                path="*"
                element={<PageNotFound pageName={window.location.pathname} />}
              />
            </Routes>
          </BrowserRouter>
        )}
      </Box>
    </>
  );
}

function PrivateRoute({ children, isLoggedIn }) {
  return isLoggedIn ? children : <Navigate to="/SignIn" />;
}
function PreLoginPAth({ children, isLoggedIn }) {
  return isLoggedIn === null ? children : <Navigate to="/Home" />;
}

function ToggleDarkMode({ toggleColorMode, colorMode }) {
  return (
    <Fab
      renderInPortal={false}
      backgroundColor={colorMode === "light" ? "light.700" : "dark.700"}
      onPress={toggleColorMode}
      position={"fixed"}
      shadow={2}
      size="sm"
      icon={
        <FontAwesomeIcon
          icon={colorMode === "light" ? faSun : faMoon}
          color={colorMode === "light" ? "gold" : "blue"}
          size="xl"
        />
      }
    />
  );
}

export default App;
